/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 月次集計
 * @export
 * @interface MonthReport
 */
export interface MonthReport {
    /**
     * 
     * @type {number}
     * @memberof MonthReport
     */
    companyId: number | null;
    /**
     * 
     * @type {number}
     * @memberof MonthReport
     */
    centerId: number | null;
    /**
     * 
     * @type {string}
     * @memberof MonthReport
     */
    itemCode: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MonthReport
     */
    recDate: Date | null;
    /**
     * 
     * @type {number}
     * @memberof MonthReport
     */
    stockoutRate: number | null;
    /**
     * 
     * @type {number}
     * @memberof MonthReport
     */
    stockoutExpectedRate: number | null;
    /**
     * 
     * @type {number}
     * @memberof MonthReport
     */
    stockDays: number | null;
    /**
     * 
     * @type {number}
     * @memberof MonthReport
     */
    stockDaysExpected: number | null;
    /**
     * 
     * @type {number}
     * @memberof MonthReport
     */
    stockDaysSetting: number | null;
    /**
     * 
     * @type {number}
     * @memberof MonthReport
     */
    safetyStockSetting: number | null;
}

/**
 * Check if a given object implements the MonthReport interface.
 */
export function instanceOfMonthReport(value: object): value is MonthReport {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('centerId' in value) || value['centerId'] === undefined) return false;
    if (!('itemCode' in value) || value['itemCode'] === undefined) return false;
    if (!('recDate' in value) || value['recDate'] === undefined) return false;
    if (!('stockoutRate' in value) || value['stockoutRate'] === undefined) return false;
    if (!('stockoutExpectedRate' in value) || value['stockoutExpectedRate'] === undefined) return false;
    if (!('stockDays' in value) || value['stockDays'] === undefined) return false;
    if (!('stockDaysExpected' in value) || value['stockDaysExpected'] === undefined) return false;
    if (!('stockDaysSetting' in value) || value['stockDaysSetting'] === undefined) return false;
    if (!('safetyStockSetting' in value) || value['safetyStockSetting'] === undefined) return false;
    return true;
}

export function MonthReportFromJSON(json: any): MonthReport {
    return MonthReportFromJSONTyped(json, false);
}

export function MonthReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonthReport {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'centerId': json['center_id'],
        'itemCode': json['item_code'],
        'recDate': (json['rec_date'] == null ? null : new Date(json['rec_date'])),
        'stockoutRate': json['stockout_rate'],
        'stockoutExpectedRate': json['stockout_expected_rate'],
        'stockDays': json['stock_days'],
        'stockDaysExpected': json['stock_days_expected'],
        'stockDaysSetting': json['stock_days_setting'],
        'safetyStockSetting': json['safety_stock_setting'],
    };
}

export function MonthReportToJSON(json: any): MonthReport {
    return MonthReportToJSONTyped(json, false);
}

export function MonthReportToJSONTyped(value?: MonthReport | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'center_id': value['centerId'],
        'item_code': value['itemCode'],
        'rec_date': value['recDate'] == null ? value['recDate'] : value['recDate'].toISOString(),
        'stockout_rate': value['stockoutRate'],
        'stockout_expected_rate': value['stockoutExpectedRate'],
        'stock_days': value['stockDays'],
        'stock_days_expected': value['stockDaysExpected'],
        'stock_days_setting': value['stockDaysSetting'],
        'safety_stock_setting': value['safetyStockSetting'],
    };
}

